let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ieHR8")).then(() => parcelRequire('ajzlr'));